import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';

import FamiliesAndFriendsHubNavigator from './FamiliesAndFriendsHubNavigator';

const Stack = createStackNavigator();

/**
 * Consumer app "Together" lane.
 * This app now keeps Together scoped to private family and friends play only.
 */
const TogetherNavigator = () => (
  <Stack.Navigator initialRouteName="FamilyHub" screenOptions={{ headerShown: false }}>
    <Stack.Screen name="FamilyHub" component={FamiliesAndFriendsHubNavigator} />
  </Stack.Navigator>
);

export default TogetherNavigator;
